var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-markdown',{staticClass:"mt-4 markdown-body",attrs:{"emoji":true,"breaks":true,"typographer":true,"lang-prefix":"markdown","source":_vm.source}})
}
var staticRenderFns = []

export { render, staticRenderFns }